import { useOrganizationId } from '@/features/organization/use-organization-id'
import { IApi, useClientApi } from '@/setup/api-client'
import { useApiQuery } from '@/utils/api/api-query'
import { IApiError } from '@/utils/api/api-types'
import { UseQueryOptions } from '@tanstack/react-query'
import type { IGetMembersResponseData } from 'api/dist/routes/organization/[organization_id]/members/index.js'

interface IGetMembersParams {
    organizationId: string
    query?: string
}

export class GetMembersQuery {
    static getKey(params: IGetMembersParams) {
        return ['organization', params.organizationId, 'members', params.query ?? '']
    }

    static async call(api: IApi, params: IGetMembersParams) {
        return api
            .get<IGetMembersResponseData>(
                `/organization/${params.organizationId}/members`,
                params.query ? { query: params.query } : undefined
            )
            .then((res) => res.data)
    }
}

export function useGetMembersQuery(
    params?: { query?: string },
    options?: Omit<UseQueryOptions<IGetMembersResponseData, IApiError>, 'queryKey' | 'queryFn'>
) {
    const api = useClientApi()
    const organizationId = useOrganizationId()

    const payload: IGetMembersParams = {
        organizationId,
        query: params?.query,
    }

    return useApiQuery<IGetMembersResponseData>({
        queryKey: GetMembersQuery.getKey(payload),
        queryFn: () => GetMembersQuery.call(api, payload),
        enabled: !!organizationId && (options?.enabled ?? true),
        ...options,
    })
}
